import React from 'react';

import { IconStyled } from './styles';

const Icon = props => {
  const { src } = props;

  return <IconStyled src={src} />;
};

export default Icon;
